import { Controller } from "@hotwired/stimulus"
import { toggleSectionVisibility } from "../src/toggle_section_visibility"

export default class extends Controller {
  static targets = [
    "container",
    "toggle",
    "track",
    "thumb",
    "repeatSection",
    "repeatSelect",
    "endDateInput",
    "conditionalSection",
    "conditionalRequiredInput",
    "dayInput"
  ]

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  changeRepeat() {
    this.sync()
  }

  dayChanged() {
    this.syncRequirements()
  }

  sync() {
    const recurring = this.hasToggleTarget && this.toggleTarget.checked
    const repeatValue = this.hasRepeatSelectTarget ? this.repeatSelectTarget.value : null
    const recurrenceVisible = this.recurrenceSectionVisible()

    this.updateSwitch(recurring)
    if (this.hasRepeatSectionTarget) {
      this.toggleSection(this.repeatSectionTarget, recurrenceVisible && recurring)
    }
    this.syncConditionalSections({ recurrenceVisible, recurring, repeatValue })

    if (this.hasRepeatSelectTarget) {
      this.repeatSelectTarget.required = recurrenceVisible && recurring
    }

    this.endDateInputTargets.forEach((input) => {
      input.required = recurrenceVisible && recurring
    })

    this.syncConditionalRequiredInputs({ recurrenceVisible, recurring, repeatValue })
    this.syncRequirements()
  }

  updateSwitch(recurring) {
    if (this.hasTrackTarget) {
      this.trackTarget.classList.toggle("toggle-switch__track--active", recurring)
    }

    if (this.hasThumbTarget) {
      this.thumbTarget.classList.toggle("toggle-switch__thumb--active", recurring)
    }
  }

  toggleSection(section, visible) {
    toggleSectionVisibility(section, visible)
  }

  syncConditionalSections(context) {
    this.conditionalSectionTargets.forEach((section) => {
      this.toggleSection(section, this.sectionVisible(section, context))
    })
  }

  syncConditionalRequiredInputs(context) {
    this.conditionalRequiredInputTargets.forEach((input) => {
      const section = input.closest("[data-recurrence-fields-target~='conditionalSection']")
      input.required = section ? this.sectionVisible(section, context) : false
    })
  }

  syncRequirements() {
    const enabledDayInputs = this.dayInputTargets.filter((input) => !input.disabled)
    const anyChecked = enabledDayInputs.some((input) => input.checked)

    this.dayInputTargets.forEach((input, index) => {
      input.required = enabledDayInputs.includes(input) && !anyChecked && enabledDayInputs[0] === input
    })
  }

  recurrenceSectionVisible() {
    if (!this.hasContainerTarget) return true

    return !this.containerTarget.classList.contains("tw-hidden")
  }

  sectionVisible(section, { recurrenceVisible, recurring, repeatValue }) {
    return recurrenceVisible && recurring && this.sectionValue(section) === repeatValue
  }

  sectionValue(section) {
    return section.dataset.recurrenceFieldsVisibleWhenValue || null
  }
}
